/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import { redirect } from 'react-router-dom';

import UserSettingsLayout from '@fai/friendli-suite/views/layout/settings/user-settings-layout';

const UserAccountPage = React.lazy(() => import('@fai/friendli-suite/pages/user-settings/account'));
const UserTeamsPage = React.lazy(() => import('@fai/friendli-suite/pages/user-settings/teams'));
const UserTokenPage = React.lazy(() => import('@fai/friendli-suite/pages/user-settings/tokens'));
const UserPoliciesPage = React.lazy(
  () => import('@fai/friendli-suite/pages/user-settings/policies')
);

const userSettingsRoutes: RouteObject[] = [
  {
    path: '*',
    Component: UserSettingsLayout,
    children: [
      {
        path: 'account',
        Component: UserAccountPage,
      },
      {
        path: 'teams',
        Component: UserTeamsPage,
      },
      {
        path: 'tokens',
        Component: UserTokenPage,
      },
      {
        path: 'policies',
        Component: UserPoliciesPage,
      },
      {
        path: '*',
        loader: () => redirect('account'),
      },
    ],
  },
];

export default userSettingsRoutes;
